const LIBRARY_LIST_PATH = '/library';
const LIBRARY_LANDING_PATH = '/library/about';

const isLibraryListOrDetail = (pathname = '') => (
  pathname === LIBRARY_LIST_PATH
  || (pathname.startsWith(`${LIBRARY_LIST_PATH}/`) && pathname !== LIBRARY_LANDING_PATH)
);

export const isLibraryDetailTransition = (from, to) => (
  from !== to && isLibraryListOrDetail(from) && isLibraryListOrDetail(to)
);
